import { CardAspectRatio } from 'common/builder/components/chart/FlowChart/types/FlowChartCardsBlock'

export const getRatio = (aspectRatio: CardAspectRatio) =>
  aspectRatio === CardAspectRatio.SQUARE ? 1 : undefined
